import {doc} from '../docs.js';
import {hashCode} from "utils/hashCode.js";
import {gl_uniform} from './variables.js';
import { float, utils, extract} from './utils.js';
import {lazy} from './lazy.js';
import {extractCode} from './extract.js';

doc(
    "gl.rgb2hsl",
    {
        "rgb vec3": ""
    },
    "Returns a vec3 of hsl representation of rgb vec3 passed in",
    () => 1,
    {
        inlets: 1
    });

export const gl_rgb2hsl = (object) => {
    object.needsHotReload = true;
    return lazy((rgb) => {
        let codes = extractCode(rgb);
        return `rgb2hsl(${float(codes[0])})`;
    });
};
    
doc(
    "gl.hsl2rgb",
    {
        "hsl vec3": ""
    },
    "Returns a vec3 of rgb representation of hsl vec3 passed in",
    () => 1,
    {
        inlets: 1
    });

export const gl_hsl2rgb = (object) => {
    object.needsHotReload = true;
    return lazy((rgb) => {
        let codes = extractCode(rgb);
        return `hsl2rgb(${float(codes[0])})`;
    });
};
 


doc(
    'gl.color',
    {
        'hexColor': "",
    },
    "Converts hex color into vec4 with uniforms",
    () => 1,
    {
        connects: {
            object: "gl.fragColor"
        }
    }
);

export const gl_color = (object) => {
    object.needsHotReload = true;
    let uniforms = {};
    return ([hex]) => {
        hex = hex.slice(1);
        let r = hex.slice(0, 2);
        let g = hex.slice(2, 4);
        let b = hex.slice(4, 6);
        let a = hex.slice(6, 8);

        let rgb = [parseInt(r, 16)/255.0, parseInt(g, 16)/255.0, parseInt(b, 16)/255.0];

        let id = object.id.replaceAll('-','');
        let uni_r = uniforms['r'] || gl_uniform(object, () => 'r' + id);
        let uni_g = uniforms['g'] || gl_uniform(object, () => 'g' + id);
        let uni_b = uniforms['b'] || gl_uniform(object, () => 'b' + id);
        uniforms['r'] = uni_r;
        uniforms['g'] = uni_g;
        uniforms['b'] = uni_b;

        let r1 = uni_r([rgb[0]], true);
        let g1 = uni_g([rgb[1]], true);
        let b1 = uni_b([rgb[2]], true);
        let code = `vec4(r${id}, g${id}, b${id}, 1.0)`;
        let ret = {
            code,
            hashCode: hashCode(code),
            variables: {},
            functions: {},
            uniforms:  {
                ... r1.uniforms,
                ... g1.uniforms,
                ... b1.uniforms
            }
        };
        return [ret];
    };
};

doc(
    "gl.hueShift",
    {
        "color": "",
        "shift amount": ""
    },
    "Shifts color's hue by a given amount",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });
export const hueShift = (object, shift) => {
    object.needsHotReload = true;
    return lazy((rgb) => {
        let codes = extractCode(rgb, shift);
        let hsl = `rgb2hsl(vec3(${float(codes[0])}.x, ${float(codes[0])}.y, ${float(codes[0])}.z))`;
        let sRGB = `hsl2rgb(vec3(mod((${hsl}).x + ${float(codes[1])}, 1.0), ${hsl}.y, ${hsl}.z))`;
        return `vec4(${sRGB}, (${codes[0]}).w)`;
    }, shift); 
};

doc(
    'gl.colorSwapRG',
    {
        "color": "vec4",
        "swap": "float"
    },
    "Conditionally swaps the R and G values in the vec4 passed in left-inlet, when 2nd inlet is 1.",
    () => 1,
    {
        isHot: true,
        inlets: 2
    }
);

export const gl_color_swap_rg = (object, swap) => {
    return lazy( color => {
        let [_color, _swap] = extractCode(color, swap);
        console.log("_swap =", _swap);
        _color = float(_color);
        _swap = float(_swap);

        return `((${_swap}) == 1.0 ? 
    vec4(${_color}.g, ${_color}.r, ${_color}.b, ${_color}.a) : ${_color})`;
    }, swap);
};

export const colors = {
    "gl.hueShift": hueShift,
    "gl.hsl2rgb": gl_hsl2rgb,
    "gl.rgb2hsl": gl_rgb2hsl,
    "gl.color": gl_color,
    "gl.colorSwapRG": gl_color_swap_rg
};
